<template>
  <div class="bg" style="background-image: url('images/bg.svg')" />
</template>

<script>
export default {
  name: "BgImage",
};
</script>

<style lang="scss" scoped>
.bg {
  display: none;

  @include media(">phone") {
    display: block;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    position: none;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.5;
    z-index: 0;
  }
}
</style>
